import { createElement } from "react";
import { toast, ToastOptions, TypeOptions } from "react-toastify";

type ToastParams = {
    type: TypeOptions;
    message: string;
} & ToastOptions;

const defaultToastOptions: ToastOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const renderToastMessage = (message: string) =>
    createElement("span", { className: "Toastify__toast-content" }, message);

export function showToast({ type, message, ...rest }: ToastParams) {
    const content = renderToastMessage(message);
    const options = { ...defaultToastOptions, ...rest };

    if (
        type === "success" ||
        type === "error" ||
        type === "info" ||
        type === "warning"
    ) {
        return toast[type](content, options);
    }
    return toast(content, options);
}

export function showNoPermissionToast(payload: Partial<ToastParams> = {}) {
    return showToast({
        type: "error",
        message: "You do not have the permission to access this feature",
        ...payload,
    });
}
